module.exports = __webpack_public_path__ + "img/utility-game.32adcba7.png";